import React from 'react';
import { currencies } from '../../../components/form/Currency';
import countryCodes from '../../../data/countryCodes';

import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText as MuiListItemText,
  ListItemSecondaryAction,
  MenuItem,
  FormControl,
  InputLabel,
  Select
} from '@material-ui/core';
import { Flare, PeopleAlt, Euro } from '@material-ui/icons/';
import Face from '@material-ui/icons/Face';
import Help from '@material-ui/icons/Help';
import EditAttributes from '@material-ui/icons/EditAttributes';
import { SwitchControl as Switch } from '../../../components/form/Switch';
import styled from 'styled-components/macro';
import { Field } from 'formik';
import FieldEngine from '../../../components/form/engine/FieldEngine';
import Disabler from '../../../components/Disabler';
import Phone from '@material-ui/icons/Phone';
import CharacterCounter from '../../CharacterCounter';

const ListItemText = styled(MuiListItemText)`
  && {
    max-width: 85%;
  }
`;

// used to compencate on different structure in the list
const CurrencyListItemWrapper = styled.div`
  && {
    padding-left: 10px;
    width: 100%;
  }
`;

const CurrencySelectWrapper = styled.div`
  width: 80%;
  line-height: 1.5;
  display: inline-block;
`;
const ListItemSecondaryActionWrapper = styled(ListItemSecondaryAction)`
  && {
    position: static;
    transform: none;
    margin-left: 1.5rem;
    margin-top: -2.1rem;
  }
`;

const TooltipSecondaryActionWrapper = styled(ListItemSecondaryAction)`
  && {
    position: static;
    transform: none;
    margin-left: 1.5rem;
  }
`;

const FieldSettingPanelView = props => {
  const { htmlId, uiType } = props;

  const TOOLTIP_MAX_CHAR = 250;

  return (
    <List>
      {uiType !== 'section_break' &&
        uiType !== 'instructional_text' &&
        uiType !== 'credas' &&
        uiType !== 'credas_out_of_scope' &&
        uiType !== 'score' &&
        uiType !== 'worldcheck' &&
        uiType !== 'worldcheck_org' &&
        uiType !== 'link' &&
        uiType !== 'thirdfort' && (
          <ListItem>
            <ListItemIcon>
              <Flare />
            </ListItemIcon>
            <ListItemText
              primary="Required"
              secondary="When toggled on, this will be a mandatory field in your workflow."
            />
            <ListItemSecondaryAction>
              <Switch
                edge="end"
                onChange={props.onRequiredToggled}
                checked={props.required}
                data-testid={`${htmlId}-required`}
              />
            </ListItemSecondaryAction>
          </ListItem>
        )}
      <ListItem>
        <ListItemIcon>
          <PeopleAlt />
        </ListItemIcon>
        <ListItemText
          primary="Visible to admin only"
          secondary="When toggled on, only system admins will see this field."
        />
        <ListItemSecondaryAction>
          <Switch
            edge="end"
            disabled={props.isAdminOnlyOptionDisabled}
            onChange={props.onAdminOnlyToggled}
            checked={props.visible2Admin}
            data-testid={`${htmlId}-admin-only`}
          />
        </ListItemSecondaryAction>
      </ListItem>
      {uiType !== 'instructional_text' &&
        uiType !== 'section_break' &&
        uiType !== 'score' && (
          <ListItem>
            <ListItemIcon>
              <Face />
            </ListItemIcon>
            <ListItemText
              primary="Read only"
              secondary="When toggled on, end users will not be allowed to edit this field."
            />
            <ListItemSecondaryAction>
              <Switch
                edge="end"
                disabled={props.visible2Admin}
                onChange={props.onReadOnlyToggled}
                checked={props.readOnly}
                data-testid={`${htmlId}-read-only`}
              />
            </ListItemSecondaryAction>
          </ListItem>
        )}
      {uiType === 'phone' && (
        <ListItem>
          <CurrencyListItemWrapper>
            <ListItemIcon>
              <Phone />
            </ListItemIcon>
            <CurrencySelectWrapper>
              <div>Choose default country code</div>
              <div>
                <Select
                  fullWidth
                  data-testid={`${htmlId}-select-country-code`}
                  value={props.defaultCountry}
                  onChange={props.onDefaultCountryChanged}
                  variant="outlined"
                >
                  {countryCodes.map(cur => (
                    <MenuItem
                      key={cur.name}
                      data-testid={`${htmlId}-select-country-code-option-${cur.dial_code}`}
                      value={cur.code}
                    >
                      {cur.name} ({cur.dial_code})
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </CurrencySelectWrapper>
          </CurrencyListItemWrapper>
        </ListItem>
      )}
      {uiType === 'currency' && (
        <ListItem>
          <CurrencyListItemWrapper>
            <ListItemIcon>
              <Euro />
            </ListItemIcon>
            <CurrencySelectWrapper>
              <div>Select currency</div>
              <div>
                <Select
                  fullWidth
                  data-testid={`${htmlId}-select-currency`}
                  value={props.currency}
                  onChange={props.onCurrencyChanged}
                  variant="outlined"
                >
                  {Object.keys(currencies).map(cur => (
                    <MenuItem
                      key={cur}
                      data-testid={`${htmlId}-select-currency-option-${cur}`}
                      value={cur}
                    >
                      {currencies[cur].name} ({currencies[cur].symbol})
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </CurrencySelectWrapper>
          </CurrencyListItemWrapper>
        </ListItem>
      )}
      {props.isDefaultValueEnabled && (
        <Disabler disabled={props.visible2Admin}>
          <ListItem>
            <ListItemIcon>
              <EditAttributes />
            </ListItemIcon>
            <ListItemText
              primary="Set default value"
              secondary="Pre select an answer for this field."
            />
            <ListItemSecondaryActionWrapper>
              <FieldEngine
                field={{
                  ...props.field,
                  title: '',
                  description: '',
                  required: false,
                  readOnly: false
                }}
                initialValue={
                  (props.field.defaultValue &&
                    props.field.defaultValue.properties &&
                    props.field.defaultValue.properties.value) ||
                  ''
                }
              />
            </ListItemSecondaryActionWrapper>
          </ListItem>
        </Disabler>
      )}
      {props.isTooltipsEnabled && (
        <ListItem>
          <ListItemIcon>
            <Help />
          </ListItemIcon>
          <ListItemText
            primary="Set tooltips"
            secondary="Add tooltips to display for each option on mouse-over."
          />
          <ListItemSecondaryAction>
            <Switch
              edge="end"
              onChange={props.onTooltipsToggled}
              checked={props.field?.annotations?.tooltips}
              data-testid={`${htmlId}-tooltips`}
            />
          </ListItemSecondaryAction>

          {props.field?.annotations?.tooltips && (
            <TooltipSecondaryActionWrapper>
              {props.field.options.map(one => (
                <div>
                  <FieldEngine
                    field={{
                      id: 'tooltip-' + one,
                      internalId: 'tooltip-' + one,
                      type: 'text',
                      uiType: 'text',
                      title: 'Tooltip for ' + one,
                      description: '',
                      required: false,
                      readOnly: false,
                      maxLength: TOOLTIP_MAX_CHAR
                    }}
                    onChangeValue={v => {
                      props.setOneTooltip(one, v);
                    }}
                    initialValue={
                      (props.field.annotations &&
                        props.field.annotations.tooltips &&
                        props.field.annotations.tooltips[one]) ||
                      ''
                    }
                    variant="tooltip"
                  />
                  <CharacterCounter
                    string={props.currentTooltips[one] || ''}
                    maxLength={TOOLTIP_MAX_CHAR}
                  />
                </div>
              ))}
            </TooltipSecondaryActionWrapper>
          )}
        </ListItem>
      )}
    </List>
  );
};

export default FieldSettingPanelView;
